<template>
	<div class="form-floating">
		<input
			v-model="localValue"
			:id="inputId"
			type="text"
			:class="['form-control', { 'is-invalid': error }]"
			:placeholder="textPlaceholder"
			:disabled="disabled"
		/>
		<label :for="inputId">{{ textPlaceholder }}</label>
		<div class="invalid-tooltip">{{ errorMsg }}</div>
	</div>
</template>

<script>
export default {
	emits: ['update:value'],
	data() {
		return {
			visible: false,
		};
	},
	props: {
		inputId: {
			type: String,
			default: '',
		},
		value: {
			type: [String, Number],
			default: '',
		},
		placeholder: {
			type: String,
			default: '',
		},
		error: {
			type: Boolean,
			default: false,
		},
		errorMsg: {
			type: String,
			default: '',
		},
		required: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		localValue: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('update:value', value);
			},
		},
		textPlaceholder() {
			return this.required ? this.placeholder + '*' : this.placeholder;
		},
	},
};
</script>

<style lang="scss">
.input-group {
	position: relative;
}
</style>
